import React, { useState } from "react";
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import { MdEmail } from "react-icons/md";
import { FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import ContactMapSection from "../layouts/ContactMapSection";

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        budget: "",
        message: ""
    });

    const [loading, setLoading] = useState(false);
    const [responseMsg, setResponseMsg] = useState("");

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        setResponseMsg("");

        const data = new FormData();

        data.append("your-name", formData.name);
        data.append("your-email", formData.email);
        data.append("your-phone", formData.phone);
        data.append("project-budget", formData.budget);
        data.append("your-message", formData.message);

        try {
            const response = await fetch(
                "https://appverselabs.codebuddys.in/wp-json/contact-form-7/v1/contact-forms/8/feedback",
                {
                    method: "POST",
                    body: data,
                }
            );

            const result = await response.json();

            if (result.status === "mail_sent") {
                setResponseMsg("Message sent successfully!");

                setFormData({
                    name: "",
                    email: "", 
                    phone: "",
                    budget: "",
                    message: "",
                });
            } else {
                setResponseMsg("Failed to send message.");
            }
        } catch (error) {
            console.error(error);
            setResponseMsg("Something went wrong.");
        }

        setLoading(false);
    };

    return (
        <>
            <Header />
            <section className="contact-section">

                {/* BG */}
                <div className="contact-grid"></div>

                <div className="contact-glow glow-1"></div>
                <div className="contact-glow glow-2"></div>

                <div className="contact-container">

                    {/* LEFT */}
                    <div className="contact-left">

                        <div className="contact-badge">
                            🚀 Contact AppVerseLabs
                        </div>

                        <h2>
                            Let’s Build Your
                            <br />
                            <span>Next Big App</span>
                        </h2>

                        <p>
                            Have an idea? We help startups and businesses
                            create premium mobile applications with modern
                            technologies and beautiful user experiences.
                        </p>

                        {/* INFO */}
                     <div className="contact-info-wrap">

    <div className="contact-info-card">

        <div className="contact-icon">
            <MdEmail />
        </div>

        <div>
            <h4>Email Us</h4>
            <span>
                hello@appverselabs.com
            </span>
        </div>

    </div>

    <div className="contact-info-card">

        <div className="contact-icon">
            <FaPhoneAlt />
        </div>

        <div>
            <h4>Call Us</h4>
            <span>
                +91 98765 43210
            </span>
        </div>

    </div>

    <div className="contact-info-card">

        <div className="contact-icon">
            <FaMapMarkerAlt />
        </div>

        <div>
            <h4>Location</h4>
            <span>
                Rajkot, Gujarat, India
            </span>
        </div>

    </div>

</div>

                    </div>

                    {/* RIGHT */}
                    <div className="contact-right">

                        <div className="contact-form-card">

                            <div className="form-glow"></div>

                            <h3>
                                Start Your Project
                            </h3>

                            <p>
                                Fill the form and our team will contact you shortly.
                            </p>

                            <form onSubmit={handleSubmit}>

                                <div className="input-group">

                                    <input
                                        type="text"
                                        name="name"
                                        placeholder="Your Name"
                                        value={formData.name}
                                        onChange={handleChange}
                                        required
                                    />

                                    <input
                                        type="email"
                                        name="email"
                                        placeholder="Email Address"
                                        value={formData.email}
                                        onChange={handleChange}
                                        required
                                    />

                                </div>

                                <div className="input-group">

                                    <input
                                        type="text"
                                        name="phone"
                                        placeholder="Phone Number"
                                        value={formData.phone}
                                        onChange={handleChange}
                                        required
                                    />

                                    <input
                                        type="text"
                                        name="budget"
                                        placeholder="Project Budget"
                                        value={formData.budget}
                                        onChange={handleChange}
                                    />

                                </div>

                                <textarea
                                    name="message"
                                    placeholder="Tell us about your project..."
                                    value={formData.message}
                                    onChange={handleChange}
                                    required
                                />

                                <button
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? "Sending..." : "Send Message →"}
                                </button>

                                {responseMsg && (
                                    <p
                                        style={{
                                            marginTop: "15px",
                                            color: responseMsg.includes("success")
                                                ? "#16a34a"
                                                : "#dc2626",
                                            fontWeight: "600",
                                            textAlign: "center",
                                        }}
                                    >
                                        {responseMsg}
                                    </p>
                                )}

                            </form>

                        </div>

                    </div>

                </div>

                <style>{`
.contact-icon{
    width:60px;
    height:60px;

    display:flex;
    align-items:center;
    justify-content:center;

    border-radius:18px;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );

    color:#fff;
    font-size:24px;

    box-shadow:
        0 12px 30px rgba(232,33,42,.25);

    flex-shrink:0;

    transition:all .35s ease;
}

.contact-info-card:hover .contact-icon{
    transform:
        translateY(-5px)
        scale(1.05);

    box-shadow:
        0 18px 40px rgba(232,33,42,.35);
}
 button.mobile-menu-btn{

    padding: 0 !important;
    color: #000 !important;

}
                .contact-section{
                    position:relative;
                    overflow:hidden;
                    padding:140px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #ffffff 0%,
                        #fff5f5 50%,
                        #ffffff 100%
                    );
                }

                .contact-container{
                    max-width:1400px;
                    margin:auto;
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:70px;
                    align-items:center;
                    position:relative;
                    z-index:2;
                }

                /* GRID */

                .contact-grid{
                    position:absolute;
                    inset:0;

                    background-image:
                    linear-gradient(
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    ),
                    linear-gradient(
                        90deg,
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    );

                    background-size:70px 70px;

                    mask-image:
                    radial-gradient(
                        circle at center,
                        black,
                        transparent 90%
                    );
                }

                /* GLOW */

                .contact-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.14;
                }

                .glow-1{
                    width:420px;
                    height:420px;
                    background:#E8212A;
                    top:-120px;
                    left:-120px;
                    animation:glowMove1 10s infinite ease-in-out;
                }

                .glow-2{
                    width:380px;
                    height:380px;
                    background:#FF4D4D;
                    bottom:-140px;
                    right:-120px;
                    animation:glowMove2 12s infinite ease-in-out;
                }

                /* LEFT */

                .contact-badge{
                    display:inline-flex;
                    align-items:center;
                    gap:10px;

                    padding:12px 24px;

                    border-radius:999px;

                    background:rgba(232,33,42,.08);

                    border:1px solid rgba(232,33,42,.14);

                    color:#E8212A;

                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;

                    margin-bottom:28px;

                    font-family:'Plus Jakarta Sans',sans-serif;

                    animation:pulse 3s infinite;
                }

                .contact-left h2{
                    font-size:clamp(35px,7vw,58px);
                    line-height:.95;
                    margin:0 0 24px;
                    color:#111;
                    
                    letter-spacing:-4px;
                    font-family:'Syne',sans-serif;
                }

                .contact-left h2 span{
                    color:#E8212A;
                }

                .contact-left p{
                    max-width:650px;
                    color:#666;
                    line-height:1.9;
                    font-size:18px;
                    margin-bottom:50px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                /* INFO CARD */

                .contact-info-wrap{
                    display:flex;
                    flex-direction:column;
                    gap:20px;
                }

                .contact-info-card{
                    display:flex;
                    align-items:center;
                    gap:22px;

                    padding:24px;

                    border-radius:28px;

                    background:#fff;

                    border:1px solid #f1f1f1;

                    box-shadow:
                    0 20px 50px rgba(0,0,0,.05);

                    transition:.45s ease;
                }

                .contact-info-card:hover{
                    transform:translateX(12px);

                    border-color:rgba(232,33,42,.16);

                    box-shadow:
                    0 30px 70px rgba(232,33,42,.12);
                }

                .contact-icon{
                    width:74px;
                    height:74px;

                    border-radius:24px;

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    font-size:30px;

                    color:#fff;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 18px 45px rgba(232,33,42,.22);

                    animation:floatIcon 4s infinite ease-in-out;
                }

                .contact-info-card h4{
                    margin:0 0 8px;
                    color:#111;
                    font-size:24px;
                    font-family:'Syne',sans-serif;
                }

                .contact-info-card span{
                    color:#666;
                    font-size:15px;
                    line-height:1.8;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                /* FORM */

                .contact-form-card{
                    position:relative;

                    padding:50px;

                    border-radius:40px;

                    background:#fff;

                    overflow:hidden;

                    border:1px solid #f1f1f1;

                    box-shadow:
                    0 30px 90px rgba(0,0,0,.06);
                }

                .form-glow{
                    position:absolute;
                    width:260px;
                    height:260px;
                    border-radius:50%;

                    background:
                    rgba(232,33,42,.12);

                    filter:blur(80px);

                    top:-120px;
                    right:-120px;
                }

                .contact-form-card h3{
                    color:#111;
                    font-size:44px;
                    margin-bottom:12px;
                    line-height:1;

                    letter-spacing:-2px;
                    font-family:'Syne',sans-serif;
                }

                .contact-form-card p{
                    color:#666;
                    line-height:1.8;
                    font-size:16px;
                    margin-bottom:36px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                form{
                    position:relative;
                    z-index:2;
                }

                .input-group{
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:18px;
                    margin-bottom:18px;
                }

                input,
                textarea{
                    width:100%;

                    padding:18px 22px;

                    border-radius:18px;

                    border:1px solid #ececec;

                    background:#fafafa;

                    font-size:15px;

                    color:#111;

                    outline:none;

                    transition:.35s ease;

                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                textarea{
                    min-height:160px;
                    resize:none;
                    margin-bottom:20px;
                }

                input:focus,
                textarea:focus{
                    border-color:#E8212A;
                    background:#fff;

                    box-shadow:
                    0 0 0 4px rgba(232,33,42,.08);
                }

                button{
                    width:100%;

                    padding:20px;

                    border:none;

                    border-radius:20px;

                    cursor:pointer;

                    color:#fff;

                    font-size:16px;
                    font-weight:700;

                    transition:.4s ease;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 22px 60px rgba(232,33,42,.2);

                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                button:hover{
                    transform:translateY(-6px);

                    box-shadow:
                    0 35px 80px rgba(232,33,42,.25);
                }

                /* ANIMATION */

                @keyframes pulse{
                    0%,100%{
                        transform:scale(1);
                    }
                    50%{
                        transform:scale(1.05);
                    }
                }

                @keyframes floatIcon{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-8px);
                    }
                }

                @keyframes glowMove1{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(60px);
                    }
                }

                @keyframes glowMove2{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-60px);
                    }
                }

                /* RESPONSIVE */

                @media(max-width:1100px){

                    .contact-container{
                        grid-template-columns:1fr;
                    }

                }

                @media(max-width:768px){

                    .contact-section{
                        padding:100px 18px;
                    }

                    .contact-left h2{
                        letter-spacing:-2px;
                    }

                    .contact-form-card{
                        padding:32px 24px;
                    }

                    .input-group{
                        grid-template-columns:1fr;
                    }

                    .contact-form-card h3{
                        font-size:36px;
                    }

                    .contact-info-card{
                        flex-direction:column;
                        align-items:flex-start;
                    }

                }

            `}</style>

            </section>
            <ContactMapSection />
            <Footer />
        </>
    );
};

export default ContactUs;